module.exports = __webpack_public_path__ + "img/review@2x.f98d098.webp";